import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as common from '../../../../../../common'
import { DEFERRED_EXCLUSION_CATEGORY_ID } from '../../../deferred-exclusions'

/**
 * TODO: - This should be refactored to use {@link graphql.transformers.IN.if}
 */
export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.rate.gl.Mapping.Entry,
  graphql.schema.RateMappingEntryInput
>({
  categorization: entry => {
    if (!entry.faFunctionCategorization) {
      return undefined
    }
    const { categoryId } = ents.extra.common.FaFunction.Categorization.Ids.from(
      entry.faFunctionCategorization,
    )
    // NOTE: - This is just a workaround in order to make the Deferred Exclusion
    // functionality work.
    if (categoryId === DEFERRED_EXCLUSION_CATEGORY_ID) {
      return undefined
    }
    return common.gql.faFunctions.inputs.categorizationIds.TRANSFORMER.getGqlFrom(
      entry.faFunctionCategorization,
    )
  },
  exclusionLabel: transformers.PASS_THROUGH,
  percent: transformers.PASS_THROUGH,
})
